import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3880fa1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "map-content",
  id: "g6_map_content"
}
const _hoisted_2 = { class: "action-bar" }
const _hoisted_3 = { id: "mountNode" }
const _hoisted_4 = { class: "drawer-content" }
const _hoisted_5 = { style: {"background-color":"#fff","padding-bottom":"5px"} }
const _hoisted_6 = {
  key: 0,
  class: "list-content"
}
const _hoisted_7 = {
  key: 1,
  class: "empty-tips"
}
const _hoisted_8 = { class: "selected-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "关联促销政策商品清单", -1))
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_12 = { style: {"height":"calc(100% - 196px)"} }
const _hoisted_13 = { class: "drawer-content" }
const _hoisted_14 = { style: {"background-color":"#fff","padding-bottom":"5px"} }
const _hoisted_15 = {
  key: 0,
  class: "list-content"
}
const _hoisted_16 = {
  key: 1,
  class: "empty-tips"
}
const _hoisted_17 = { class: "selected-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "关联特殊折扣商品清单", -1))
const _hoisted_19 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_input_search = _resolveComponent("oio-input-search")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_oio_spin = _resolveComponent("oio-spin")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_OioTextarea = _resolveComponent("OioTextarea")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_OioDateTimePicker = _resolveComponent("OioDateTimePicker")!
  const _component_oio_col = _resolveComponent("oio-col")!
  const _component_oio_row = _resolveComponent("oio-row")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_oio_switch = _resolveComponent("oio-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_oio_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onGroup('and'))),
        disabled: !_ctx.canGroup
      }, {
        default: _withCtx(() => [
          _createTextVNode("组“且”")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_oio_button, {
        type: "default",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onGroup('or'))),
        disabled: !_ctx.canGroup
      }, {
        default: _withCtx(() => [
          _createTextVNode("组“或”")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_oio_button, {
        type: "default",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitTree(false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("点此在控制台查看JSON数据")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        class: _normalizeClass(['iconfont', _ctx.isFullScreen ? 'icon-tuichuquanping' : 'icon-quanping']),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isFullScreen = !_ctx.isFullScreen))
      }, null, 2)
    ]),
    _createVNode(_component_a_drawer, {
      class: "oio-drawer",
      visible: _ctx.showLinkModal,
      title: "关联商品清单",
      placement: "right",
      getContainer: "#mountNode",
      onClose: _ctx.onLinkModalClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_oio_input_search, {
              value: _ctx.searchLinkStr,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchLinkStr) = $event)),
              onSearch: _ctx.onLinkSearch,
              autocomplete: "off"
            }, null, 8, ["value", "onSearch"])
          ]),
          _createVNode(_component_oio_spin, { loading: _ctx.searchLinkLoading }, {
            default: _withCtx(() => [
              (_ctx.showLinkList.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.selectedLinkName,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedLinkName) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showLinkList, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "list-item",
                            key: index
                          }, [
                            _createVNode(_component_a_radio, {
                              value: item.merchBillName,
                              onClick: _ctx.onLinkChange
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.merchBillName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "onClick"])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无数据"))
            ]),
            _: 1
          }, 8, ["loading"]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.selectedLinkName || '暂无数据'), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_a_drawer, {
      class: "oio-drawer",
      visible: _ctx.showPolicyModal,
      title: "促销政策配置",
      placement: "right",
      getContainer: "#mountNode",
      onClose: _ctx.onPolicyModalClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_oio_form, {
          ref: "policyFormRef",
          data: _ctx.rowData[_ctx.activeNode.dataId].policyInfo
        }, {
          default: _withCtx(() => [
            _createVNode(_component_oio_form_item, {
              name: "name",
              label: "政策名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_OioTextarea, {
                  rows: 3,
                  value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.name,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.name) = $event)),
                  autocomplete: "off",
                  placeholder: "请输入政策名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, {
              name: "policyThemes",
              label: "政策主题",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_OioTextarea, {
                  rows: 3,
                  value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.policyThemes,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.policyThemes) = $event)),
                  autocomplete: "off",
                  placeholder: "请输入政策主题"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, {
              name: "policyLabel",
              label: "政策标签",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_OioTextarea, {
                  rows: 3,
                  value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.policyLabel,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.policyLabel) = $event)),
                  placeholder: "请输入政策标签"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, {
              name: "accountTimeRule",
              label: "记账时间规则"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown",
                  value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.accountTimeRule,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.accountTimeRule) = $event)),
                  placeholder: "请按需选择指定记账时间",
                  allowClear: "",
                  defaultActiveFirstOption: false,
                  onChange: _ctx.handleTimeRuleChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "DELIVERY_TIME" }, {
                      default: _withCtx(() => [
                        _createTextVNode("按发货时间记账")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "TARGET_TIME" }, {
                      default: _withCtx(() => [
                        _createTextVNode("按指定时间记账")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _: 1
            }),
            (_ctx.rowData[_ctx.activeNode.dataId].policyInfo.accountTimeRule === 'DELIVERY_TIME')
              ? (_openBlock(), _createBlock(_component_oio_form_item, {
                  key: 0,
                  name: "paymentDays",
                  label: "指定账期天数",
                  required: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.accountTimeRule === 'DELIVERY_TIME'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_input, {
                      value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.paymentDays,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.paymentDays) = $event)),
                      placeholder: "请按需录入指定账期天数",
                      onChange: _ctx.limitNum
                    }, null, 8, ["value", "onChange"])
                  ]),
                  _: 1
                }, 8, ["required"]))
              : _createCommentVNode("", true),
            (_ctx.rowData[_ctx.activeNode.dataId].policyInfo.accountTimeRule === 'TARGET_TIME')
              ? (_openBlock(), _createBlock(_component_oio_form_item, {
                  key: 1,
                  name: "accountDate",
                  label: "指定账期时间",
                  required: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.accountTimeRule === 'TARGET_TIME'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_OioDateTimePicker, {
                      value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.accountDate,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.accountDate) = $event)),
                      placeholder: "请按需录入指定账期时间"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["required"]))
              : _createCommentVNode("", true),
            _createVNode(_component_oio_form_item, {
              name: "promotionType",
              label: "促销类型",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown",
                  value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.promotionType,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.promotionType) = $event)),
                  placeholder: "请选择促销类型",
                  allowClear: "",
                  defaultActiveFirstOption: false,
                  options: _ctx.baseData.promotionTypeEnumList,
                  onChange: _ctx.promotionTypeChange
                }, null, 8, ["value", "options", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_oio_form_item, { label: "让利归属" }, {
              default: _withCtx(() => [
                _createVNode(_component_oio_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_form_item, {
                          name: "platformDiscount",
                          label: "总部",
                          rules: [{ validator: _ctx.validatePlatformDiscount, trigger: 'blur' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oio_input, {
                              value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.platformDiscount,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.platformDiscount) = $event)),
                              placeholder: "",
                              suffix: "%"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_oio_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_form_item, {
                          name: "provinceDiscount",
                          label: "省区",
                          rules: [{ validator: _ctx.validateProvinceDiscount, trigger: 'blur' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oio_input, {
                              value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.provinceDiscount,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.provinceDiscount) = $event)),
                              placeholder: "",
                              suffix: "%"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_oio_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_form_item, {
                          name: "productDiscount",
                          label: "产品公司",
                          rules: [{ validator: _ctx.validateProductDiscount, trigger: 'blur' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oio_input, {
                              value: _ctx.rowData[_ctx.activeNode.dataId].policyInfo.productDiscount,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].policyInfo.productDiscount) = $event)),
                              placeholder: "",
                              suffix: "%"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_a_drawer, {
      class: "oio-drawer",
      visible: _ctx.showRightsSettingModal,
      title: "权益信息配置",
      placement: "right",
      getContainer: "#mountNode",
      onClose: _ctx.onRightsSettingClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_oio_form, {
            ref: "rightsSettingsFormRef",
            data: _ctx.rowData[_ctx.activeNode.dataId].equityInformationRule,
            layout: "horizontal",
            "label-col": { span: 10 },
            "wrapper-col": { span: 14 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_form_item, {
                name: "name",
                label: "权益名称",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_OioTextarea, {
                    allowClear: "",
                    value: _ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.name,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.name) = $event)),
                    autocomplete: "off",
                    rows: 3
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              (_ctx.showRealPrice)
                ? (_openBlock(), _createBlock(_component_oio_form_item, {
                    key: 0,
                    name: "realPriceNotBenefits",
                    label: "实价产品不让利"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oio_switch, {
                        checked: _ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.realPriceNotBenefits,
                        "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.realPriceNotBenefits) = $event)),
                        disabled: _ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.isAdvanced
                      }, null, 8, ["checked", "disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showOnePrice)
                ? (_openBlock(), _createBlock(_component_oio_form_item, {
                    key: 1,
                    name: "buyItNotBenefits",
                    label: "一口价产品不让利"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oio_switch, {
                        checked: _ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.buyItNotBenefits,
                        "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.buyItNotBenefits) = $event)),
                        disabled: _ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.isAdvanced
                      }, null, 8, ["checked", "disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showAdvanceSetting)
                ? (_openBlock(), _createBlock(_component_oio_form_item, {
                    key: 2,
                    name: "isAdvanced",
                    label: "高级配置"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oio_switch, {
                        checked: _ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.isAdvanced,
                        "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.isAdvanced) = $event)),
                        onChange: _ctx.onRightsAdvancedChange
                      }, null, 8, ["checked", "onChange"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data"]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_oio_input_search, {
                  value: _ctx.searchLinkStr,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.searchLinkStr) = $event)),
                  onSearch: _ctx.onLinkSearch,
                  autocomplete: "off"
                }, null, 8, ["value", "onSearch"])
              ]),
              _createVNode(_component_oio_spin, { loading: _ctx.searchLinkLoading }, {
                default: _withCtx(() => [
                  (_ctx.showLinkList.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.advanceItemStr,
                          "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.advanceItemStr) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showLinkList, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "list-item",
                                key: index
                              }, [
                                _createVNode(_component_a_radio, {
                                  value: item.merchBillName,
                                  onClick: _ctx.onRightsLinkChange
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.merchBillName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onClick"])
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, "暂无数据"))
                ]),
                _: 1
              }, 8, ["loading"]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.advanceItemStr || '暂无数据'), 1)
              ])
            ])
          ], 512), [
            [_vShow, _ctx.rowData[_ctx.activeNode.dataId].equityInformationRule.isAdvanced]
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ]))
}